import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_MATERIAL_REQUEST_TEMPLATES: createSagaAction('GET_MATERIAL_REQUEST_TEMPLATES'),
  GET_MATERIAL_REQUEST_TEMPLATE_ITEMS: createSagaAction('GET_MATERIAL_REQUEST_TEMPLATE_ITEMS')
}

// Action Creators
export const actions = {
  getMaterialRequestTemplates: () => ({
    type: constants.GET_MATERIAL_REQUEST_TEMPLATES.ACTION
  }),

  getMaterialRequestTemplateItems: materialRequestId => ({
    type: constants.GET_MATERIAL_REQUEST_TEMPLATE_ITEMS.ACTION,
    materialRequestId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_MATERIAL_REQUEST_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_MATERIAL_REQUEST_TEMPLATES.SUCCESS:
      return {
        ...state,
        materialRequestTemplates: action.payload
      }
    case constants.GET_MATERIAL_REQUEST_TEMPLATE_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_MATERIAL_REQUEST_TEMPLATE_ITEMS.SUCCESS:
      return {
        ...state,
        materialRequestTemplateItems: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/materialRequestTemplatesActions.js